/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserSalesFilterListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterFactory,
		UserSalesFilterListDtoSearchFactory,
		UserSalesFilterViewDtoFactory
	) {
		$scope.salesFilterList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilter)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilter);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeSalesFilter = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-salesfilter.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		$scope.getSalesFilterList = function() {
			UserSalesFilterListDtoSearchFactory.query(
				{
					salesStatus: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,
					userId: angular.isDefined($scope.userId) ? $scope.userId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getSalesFilterList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedSalesFilterId = id;
			$('#deleteSalesFilterConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserSalesFilterViewDtoFactory.delete(
				{ id: $scope.selectedSalesFilterId },
				function() {
					$scope.loadAll();
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteSalesFilterConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
